import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fonts,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";
import type { ReactNode } from "react";

export function SideBlock({
  title,
  subtitle,
  lead,
  children,
}: {
  readonly title: string;
  readonly subtitle?: string;
  readonly lead?: string | null;
  readonly children: ReactNode;
}) {
  const headingId = `side-${title.toLowerCase().replace(/\s+/g, "-")}`;
  return (
    <section aria-labelledby={headingId} {...stylex.props(styles.section)}>
      <header {...stylex.props(styles.header)}>
        <h2 id={headingId} {...stylex.props(styles.title)}>
          {title}
        </h2>
        {subtitle ? (
          <span {...stylex.props(styles.subtitle)}>{subtitle}</span>
        ) : null}
      </header>
      {lead ? <p {...stylex.props(styles.lead)}>{lead}</p> : null}
      {children}
    </section>
  );
}

const styles = stylex.create({
  section: { display: "flex", flexDirection: "column", gap: spacing.space8 },
  header: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "baseline",
    columnGap: spacing.space10,
    rowGap: spacing.space2,
  },
  title: {
    margin: 0,
    fontFamily: fonts.mono,
    fontSize: fontSizes.label,
    lineHeight: 1.286,
    fontWeight: 600,
    color: colors.foreground,
  },
  subtitle: {
    fontFamily: fonts.sans,
    fontSize: fontSizes.caption,
    lineHeight: 1.333,
    color: colors.subtle,
  },
  lead: {
    margin: 0,
    fontFamily: fonts.sans,
    fontSize: fontSizes.small,
    lineHeight: 1.385,
    color: colors.secondary,
  },
});
